/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wifi_Mesh_NetworkInputs */



/**
* | output |
* | --- |
* | "Wifi Mesh network" |
*
* @param {Wifi_Mesh_NetworkInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const wifi_mesh_network = /** @type {((inputs?: Wifi_Mesh_NetworkInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wifi_Mesh_NetworkInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Wifi Mesh network")
	return /** @type {LocalizedString} */ ("Réseau Wifi Mesh")
});